import { Component, OnInit } from '@angular/core';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { ModalController } from '@ionic/angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-broadcast',
  templateUrl: './broadcast.page.html',
  styleUrls: ['./broadcast.page.scss'],
})
export class BroadcastPage implements OnInit {
  dataForm: FormGroup;
  isLoading: boolean = false;
  constructor(public restApi: RestApiService, public modalController: ModalController, public commonFunctions: CommonFunctionsService) {
    General_Config.active_page = 'Broadcast';
  }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'target': new FormControl('all', [Validators.required]),
      'title': new FormControl(null, [Validators.required]),
      'message': new FormControl(null, [Validators.required])
    });
  }

  update() {
    this.isLoading = true;
    var formData = new FormData();
    for (let key in this.dataForm.value) {
      let value = this.dataForm.value[key];
      formData.append(key, value);
    }
    this.restApi.post('broadcast', formData).subscribe((data: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

}
